export default [
  {
    text: "Home",
    path: "/home",
    icon: "fa-solid fa-house"
  },
  {
    text: "Master",
    icon: "fa-solid fa-star",
    items: [
      {
        text: "Pelanggan",
        path: "/pelanggan"
      },
      {
        text: "Supplier",
        path: "/supplier"
      },
      {
        text: "Akun",
        path: "/akun"
      },
      {
        text: "Aset",
        path: "/aset"
      },
      {
        text: "Pengguna",
        path: "/pengguna"
      },
      {
        text: "Jabatan",
        path: "/jabatan"
      }
    ]
  },
  {
    text: "Transaksi",
    icon: "fa-solid fa-right-left",
    items: [
      {
        text: "Penjualan",
        path: "/jual"
      },
      {
        text: "Pembelian",
        path: "/beli"
      },
      {
        text: "Piutang",
        path: "/piutang"
      },
      {
        text: "Penyesuaian Piutang",
        path: "/piutang_adj"
      },
      {
        text: "Hutang",
        path: "/hutang"
      },
      {
        text: "Penyesuaian Hutang",
        path: "/hutang_adj"
      },
      {
        text: "Biaya",
        path: "/biaya"
      },
      {
        text: "Penyusutan",
        path: "/penyusutan"
      },
      {
        text: "Pendapatan",
        path: "/pendapatan"
      },
      {
        text: "Jurnal Umum",
        path: "/jurnal"
      },
    ],
  },
  {
    text: 'Laporan',
    icon: 'fa-solid fa-calculator',
    items: [
      {
        text: "Neraca Saldo",
        path: "/neraca_saldo"
      },
      {
        text: "Neraca",
        path: "/neraca"
      },
      {
        text: "Laba Rugi",
        path: "/laba_rugi"
      },
      {
        text: "Daftar Jurnal",
        path: "/daftar_jurnal"
      },
      {
        text: "Buku Besar",
        path: "/buku_besar"
      },
      {
        text: "Kartu Hutang",
        path: "/kartu_hutang"
      },
      {
        text: "Kartu Piutang",
        path: "/kartu_piutang"
      },
    ]
  },
  {
    text: "Setting",
    icon: "fa-solid fa-gear",
    path: "/setting"
  }
];
